/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".view-content-mode[_ngcontent-%COMP%]{padding-bottom:24px}"];
export { styles as styles };
